/*
 * File: d:\projects\AutoFiFront\src\Content\Car\CarsDisplay\CarsDisplay.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Thursday February 23rd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Thursday February 23rd 2023 5:22:39 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import styles from "Content/Car/CarsDisplay/CarsDisplay.module.css";
import { CarCardPropsType } from "Content/Car/CarCard/CarCard.type";
import CarCard from "Content/Car/CarCard/CarCard";
import { CarListable } from "../CarList/CarList.type";

type CarsDisplayType= {
    carList: CarListable[],
    themeColor: string,
}

function CarsDisplay (props: CarsDisplayType){
    return (
        <div className={`${styles.container}`}>
            {
                props.carList.map((car: CarListable) => { return <CarCard hasEllipsis={true} key={car.id} {...car } themeColor={props.themeColor}/>})
            }
        </div>
    );
}

export default CarsDisplay;
